var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"wo-panel wo-placeholder-panel"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v("Content for this tab is not configured yet.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }